<!-- @format -->

<div class="modal-header">
  <h2 class="modal-title" translate>{{ values.title }}</h2>
</div>
<div class="modal-body">
  @if (this.virusModal) {
    <p>{{ "FILE_UPLOAD.INVALID_VIRUS_FILES" | translate }}</p>
  }
  @if (!this.virusModal) {
    <p>{{ "FILE_UPLOAD.INVALID_FILES" | translate }}</p>
  }
  @for (file of values.invalidFileSize; track file) {
    <div class="object file-preview">
      <span class="file-name">{{ file.name }} ({{ readableFileSizeString(file.size) }})</span>
      <p class="error-message">
        <sis-icon icon="alert" color="danger"></sis-icon
        >{{ "FILE_UPLOAD.ACCEPTED_FILE_SIZE_GOES_OVER" | translate: { x: values.maxFileSizeString } }}
      </p>
    </div>
  }
  @for (file of values.invalidFileFormat; track file) {
    <div class="object file-preview">
      <span class="file-name">{{ file.name }} ({{ readableFileSizeString(file.size) }})</span>
      <p class="error-message"> <sis-icon icon="alert" color="danger"></sis-icon>{{ "FILE_UPLOAD.UNACCEPTED_FILE_FORMAT" | translate }} </p>
    </div>
  }
  @for (file of values.filesWithSameFileName; track file) {
    <div class="object file-preview">
      <span class="file-name">{{ file.name }} ({{ readableFileSizeString(file.size) }})</span>
      @if (!values.editPossible) {
        <p class="error-message"><sis-icon icon="alert" color="danger"></sis-icon>{{ "FILE_UPLOAD.SAME_FILE_NAME" | translate }}</p>
      }
      @if (values.editPossible) {
        <p class="error-message"
          ><sis-icon icon="alert" color="danger"></sis-icon>{{ "FILE_UPLOAD.SAME_FILE_NAME_ABLE_TO_EDIT" | translate }}</p
        >
      }
    </div>
  }
  @for (file of values.filesWithInvalidFileName; track file) {
    <div class="object file-preview">
      <span class="file-name">{{ file.name }} ({{ readableFileSizeString(file.size) }})</span>
      <p class="error-message">
        <sis-icon icon="alert" color="danger"></sis-icon>{{ "FILE_UPLOAD.INVALID_FILENAME_MESSAGE" | translate }}
      </p>
    </div>
  }
  @if (this.virusModal) {
    @for (file of values.filesWithVirus; track file) {
      <div class="object file-preview">
        <span class="file-name">{{ file.name }} ({{ readableFileSizeString(file.size) }})</span>
      </div>
    }
    <p class="status">{{ "FILE_UPLOAD.UNABLE_TO_SEND_FILES" | translate }}</p>
  }
  @if (this.otherAcceptedFiles) {
    <p class="status">{{ "FILE_UPLOAD.OTHER_ACCEPTED" | translate }}</p>
  }
</div>
<div class="modal-footer">
  <button
    class="btn btn-primary btn-lg"
    type="button"
    (click)="modalInstance.close()"
    [translate]="values.confirmText || 'SIS_COMPONENTS.BUTTON.OK'"></button>
</div>
